import cn from 'classnames';
import { useCallback, useState } from 'react';
import { IstatisticsParams } from '@api/types';
import ArticleTitle from '@components/article-title';
import Dropdown from '@components/dropdown';
import StatCard from '@components/user-profile/components/stat-card';
import useProfile from '@hooks/useProfile';
import styles from './statistics-profile.module.scss';

type TstatsPages = 'total' | 'coinflip' | 'jackpot' | 'blackjack';
const options: { name: string; value: TstatsPages }[] = [
    {
        name: 'total',
        value: 'total',
    },
    {
        name: 'coinflip',
        value: 'coinflip',
    },
    {
        name: 'jackpot',
        value: 'jackpot',
    },
    {
        name: 'blackjack',
        value: 'blackjack',
    },
];

function BigStat({ statistics }: { statistics: IstatisticsParams }) {
    const win_ratio = Math.floor(
        (statistics.games_won / statistics.total) * 100,
    );

    return (
        <div className={cn(styles.stat, styles.big_stat)}>
            <StatCard
                name="Total Games"
                value={statistics.total}
                className={styles['statcard--left-align']}
            />
            <StatCard name="Games Win" value={statistics.games_won} />
            <StatCard name="Games Lost" value={statistics.games_lose} />
            <StatCard
                name="Win Ratio"
                value={win_ratio}
                percentage
                className={styles['statcard--left-align']}
            />
        </div>
    );
}

function Statistics({
    statistics,
}: {
    statistics: IstatisticsParams;
}): JSX.Element {
    return (
        <div className={styles.stats}>
            <BigStat statistics={statistics} />
            <hr />

            <div className={styles.money_stats}>
                <StatCard
                    name="Wagered"
                    value={statistics.wagered}
                    withCoinIcon
                    position="left"
                />
                <StatCard
                    name="Max Profit"
                    value={statistics.max_profit}
                    withCoinIcon
                    position="left"
                />
                <StatCard
                    name="Total Profit"
                    value={statistics.profits}
                    withCoinIcon
                    position="left"
                />
            </div>
        </div>
    );
}

export default function StatisticsProfile(): JSX.Element {
    const [currentStat, setCurrentStat] = useState<TstatsPages>('total');
    const user = useProfile();
    const statistics = user.statistics[currentStat];

    const changeCurrentStat = useCallback(
        (stat: TstatsPages) => {
            setCurrentStat(stat);
        },
        [currentStat],
    );

    return (
        <div className={styles.statistics}>
            <div className={styles.stats_header}>
                <ArticleTitle title="Statistics" />
                <Dropdown
                    value={currentStat}
                    onChange={changeCurrentStat}
                    options={options}
                    className={styles.dropdown}
                />
            </div>
            <Statistics statistics={statistics} />
        </div>
    );
}
